<template>
	<Link
		as="v-card"
		class="flex d-flex flex-column"
		ripple
		link
		tag="a"
		:href="
			$route('shop.categories.show', {
				tenant: $page.props.tenant.id,
				outlet: $route().params.outlet,
				category: category.uuid,
			})
		"
	>
		<v-img
			height="120"
			:src="category.image_url"
			class="amber accent-4"
			contain
		></v-img>
		<v-card-title primary-title class="text-center align-center">
			<div
				v-line-clamp:20="2"
				class="text-center align-center"
				style="width: 100%"
			>
				{{ category.name }}
			</div>
		</v-card-title>
		<v-card-text class="fill-height"> </v-card-text>
	</Link>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: {
		Link,
	},
	props: ["category"],
};
</script>